export const credentialsErrorMessage = (data) => {
    if (!data) {
        return "";
    }

    const keys = Object.keys(data);
    return keys.length > 0 ? data[keys[0]] : "";
};

export default {};
